<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_phone_dial_in_contacts)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.99975 0C1.79075 0 0 1.79086 0 4V12C0 14.2091 1.79075 16 3.99975 16H10.9993C13.2083 16 14.9991 14.2091 14.9991 12L15.5 11.9999C15.7761 11.9999 16 11.7761 16 11.4999V10.4999C16 10.2238 15.7761 9.99994 15.5 9.99994H14.9991V5.99994H15.5C15.7761 5.99994 16 5.77608 16 5.49994V4.49994C16 4.2238 15.7761 3.99994 15.5 3.99994H14.9991C14.9991 1.79083 13.2083 0 10.9993 0H3.99975ZM10.9993 1H3.99975C2.343 1 0.99994 2.34315 0.99994 4V12C0.99994 13.6569 2.34301 15 3.99975 15H10.9993C12.6561 15 13.9991 13.6569 13.9991 12V4C13.9991 2.34315 12.6561 1 10.9993 1ZM9.74808 9.50005H9.16136C8.89579 9.50005 8.64109 9.6054 8.45331 9.79293L7.93132 10.3142C7.82534 10.42 7.66434 10.4575 7.52602 10.3998C6.42977 9.94295 5.55466 9.06751 5.09932 7.97166C5.04198 7.83367 5.07954 7.67326 5.18532 7.56762L5.71071 7.04295C5.89852 6.85539 6.00403 6.60102 6.00403 6.33578V5.75003C6.00403 5.19774 5.55568 4.75003 5.00261 4.75003H4.25161C3.41981 4.75003 2.74812 5.43038 2.74949 6.261C2.75537 9.84202 5.66137 12.7433 9.24736 12.7495L9.25112 12.7497C9.25366 12.7497 9.2561 12.75 9.25864 12.75V12.7489C10.0829 12.7427 10.7495 12.0746 10.7495 11.25V10.5C10.7495 9.94776 10.3012 9.50005 9.74808 9.50005Z" />
      <path
        d="M9 5.32812L10.9746 3.35352C11.1699 3.15827 11.4864 3.15827 11.6816 3.35352C11.8769 3.54876 11.8769 3.86531 11.6816 4.06055L9.74219 6H11.5C11.7761 6 12 6.22386 12 6.5C12 6.77614 11.7761 7 11.5 7H8V3.5C8 3.22386 8.22386 3 8.5 3C8.77614 3 9 3.22386 9 3.5V5.32812Z" />
    </g>
    <defs>
      <clipPath id="clip0_phone_dial_in_contacts">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'phone-dial-in-contacts'
})
</script>
